<template>
  <div>
    <menubar :permission="permission"/>

    <div class="container">

      <Title title="ファイル翻訳"/>

      <TranslationOptions @update-value="handleUpdateValue"/>

      <!-- 
      ファイル翻訳に使用するファイルの指定
      -->
      <div class="file-translation-main drop_area"
        :class="classesDragArea"  
        @dragover.prevent="onArea"
        @drop.prevent="dropFile" 
        @dragleave.prevent="offArea"
      >
          <div class="content-text">
            <span>翻訳するファイルをドラッグ＆ドロップする<br></span>
            <span>または<br></span>
            <label>
              <span class="trans-file-btn">ファイルを選択</span>
              <input type=file id="trans-file-input" 
                accept=".xlsx,.xlsm,.xls,.srt,.docx,.doc,.txt"
                @input="form.file = $event.target.files[0]" 
                @change="validateFile" 
                ref=file
              >
            </label>
            <div class="supported-file-types" aria-label="対応ファイル形式">
              <div class="supported-file-types__row">
                <span class="supported-file-types__label">対応拡張子</span>
                <span class="supported-file-types__body">Excel（.xlsx / .xlsm / .xls）、SRT（.srt）</span>
              </div>
              <div class="supported-file-types__row">
                <span class="supported-file-types__label">Excel必須列</span>
                <span class="supported-file-types__body">「原文」または「原文テキスト」</span>
              </div>
              <div class="supported-file-types__row">
                <span class="supported-file-types__label">Excel任意列</span>
                <span class="supported-file-types__body">「表示開始時間」/「IN点」/「start」、「表示終了時間」/「OUT点」/「end」、「字幕番号」/「番号」、「トラック」/「レイヤー」</span>
              </div>
            </div>

            <span id="trans_file_name" v-show="form.file.name">
              {{ form.file.name }}
              <span class="reset_file_ico" @click="resetFile()">
                クリア
              </span>
            </span>
          </div>
      </div>

      <div class="d-flex align-items-center justify-content-center">
        <TranslationButton :disabled="translation_options.selectedAimodel != ''" @click="translate()"/>
      </div>

    </div>

    <section v-show="isModalDisplay" id="modalArea" class="modalArea">
      <div class="modalWrapper">
        <div v-show="isDataUpload" class="modalContents">
          <h1 id="modalMessage">ファイルを保存しています<br>画面を閉じずにそのままお待ちください</h1><span class="loading"></span>
        </div>
        <div v-show="isRedirectPage" class="modalContents">
          <h1 id="modalMessage">ファイルの保存が完了しました。</h1>
          <button type="button" class="btn btn-light redirect-page-button" @click="redirect_translated_bilingual_files()">確認画面へ</button>
          <button type="button" class="btn btn-light redirect-page-button" @click="redirect_file_translate()">別ファイルを翻訳</button>
        </div>
      </div>
    </section>
  
    <footerComponent />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Link, useForm } from '@inertiajs/inertia-vue3'
import Button from "@/Jetstream/Button.vue";
import menubar from "@/Pages/Common/menu.vue";
import footerComponent from "@/Pages/Components/footer.vue";
import modal from "@/Pages/Components/modal.vue";

import Title from "@/Pages/Components/Title.vue";
import TranslationOptions from "@/Pages/Components/TranslationOptions.vue";
import TranslationButton from "@/Pages/Components/TranslationButton.vue";

export default defineComponent({
  setup () {
    const form = useForm({file: '',})
    return { form }
  },
  components: {
    Title,
    TranslationOptions,
    TranslationButton,
    menubar, 
    Button, 
    footerComponent, 
    modal
  },
  props: {
    aimodels: Object,
    glossaries: Object,
    translatedFile: Number,
    permission:String,
  },
  data() {
    return {
      isRedirectPage: false,
      isDataUpload: false,
      isModalDisplay: false,
      alert_message: "",
      trans_file: {},
      inArea: false,
      limit: 0,
      unit: '',
      allow: '',
      allowType: [],
      lists: {
        'mimeType': {
          'gif':  'image/gif',
          'jpg':  'image/jpeg',
          'png':  'image/png',
          'text': 'text/plain',
          'tsv':  'text/tab-separated-values',
          'csv':  [ 'application/vnd.ms-excel', 'text/csv' ],
          'pdf':  'application/pdf',
          'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'doc': 'application/msword',
          'txt': 'text/plain',
          'xls': 'application/vnd.ms-excel',
          'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'srt': 'application/x-subrip'
        },
        'unit': {
          'kb': 1000,
          'mb': 1000000,
          'gb': 1000000000,
        }
      },
      translation_options: {
        selectedSourceLanguage: "英",
        selectedTargetLanguage: "日",
        selectedAimodel: "",
        selectedGlossary: "",
      },
    };
  },

  computed: {
    classesDragArea () {
      return {
        'drag_on': this.inArea
      }
    }
  },

  methods: {
    handleUpdateValue: function(value){
      this.translation_options = value;
      console.log(value);
    },

    onArea  () { this.inArea = true  },
    offArea () { this.inArea = false },
    redirect_translated_bilingual_files () {
      this.$inertia.get(route('translated_bilingual_files.index'))
    },
    redirect_file_translate () {
      this.$inertia.get(route('file_translate.index'))
    },

    validateTranslate: function(){
      this.alert_message = '';
      if ( this.form.file === '' ) {
        this.alert_message += "ファイルが選択されていません\n";
      }
      if ( this.form.aimodel === '' ) {
        this.alert_message += "モデルが選択されていません\n";
      }
      if (this.alert_message !== '') {
        alert(this.alert_message);
        return false;
      }else{
        return true;
      }
    },
    async translate(){
      if (this.translation_options.selectedAimodel == '') return false;

      // 実行
      if (window.confirm("翻訳を実行してよろしいですか？")){
        this.isModalDisplay = true;
        this.isDataUpload   = true;

        this.form.aimodel = this.translation_options.selectedAimodel;
        this.form.glossary = this.translation_options.selectedGlossary;
        this.form.selectedSourceLanguage = this.translation_options.selectedSourceLanguage;
        this.form.selectedTargetLanguage = this.translation_options.selectedTargetLanguage;

        this.$inertia.post(
          '/file_translate', 
          this.form,
          {
            onSuccess: (data) => {
              console.log("Finish tasks");
              this.isDataUpload   = false;
              this.isRedirectPage = true;
            },
            onError: (data) => {
              // alert('ファイル翻訳に失敗しました。形式の確認をお願いします。');
              alert(data[0]);
              this.isModalDisplay = false;
            },
          only: []
          });

      }else{
        alert("キャンセルされました");
      }
    },
    dropFile(e) {
      let files = e.target.files || e.dataTransfer.files;
      this.form.file = files[0];
      this.validateFile(e)
      this.offArea()
    },
    resetFile () {
        this.$refs.file.value = '';
        this.form.file = '';
    },
    validateFile: function(e) {

      if (!this.isAllowFileType(this.form.file)) {
        alert("対応しているファイル形式は" + this.allow + "です");
        this.resetFile();
        return false;
      }
      if (!this.isAllowFileSize(this.form.file.size)) {
        alert("実行可能なファイルサイズを超えています");
        this.resetFile();
        return false;
      }
      console.log(this.form.file.name)
      return true;
    },
    isAllowFileType(file) {
      const extension = file.name.split('.').pop().toLowerCase();
      if (this.allow.includes(extension)) {
        return true;
      }

      return this.allowType.indexOf(file.type) !== -1
    },
    isAllowFileSize(size) {
      return parseInt(size) < this._getLimitSizeByte()
    },
    getErrorMessageSize() {
      return this.limit + this.unit + '未満のファイルのみアップロード可能です'
    },
    getErrorMessageType() {
      return this.allow.join('・') + ' 形式ファイルのみアップロード可能です'
    },
    _getAllowMimeType(allow) {
      let mimeTypes = []
      for (let i = 0; i < allow.length; i++) {
        let target = this.lists.mimeType[allow[i]];
        if (typeof target === 'string') {
          mimeTypes.push(target);
        } else if (target instanceof Array) {
          mimeTypes = mimeTypes.concat(target);
        }
      }
      return mimeTypes;
    },
    _getLimitSizeByte() {
      return this.limit * this.lists.unit[this.unit]
    }
  },
  mounted: function(){
    this.limit     = 1
    this.unit      = 'gb'
    this.allow     = [ 'xlsx', 'xlsm', 'xls', 'srt', 'docx', 'doc', 'txt' ]
    this.allowType = this._getAllowMimeType(this.allow)
  },

});
</script>

<style lang="scss" scoped>

#file-translation-head{
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem;
  #selection{
    display: flex;
    justify-content: end;
    align-items: center;
    #aimodel-selection{
      margin: 0 1rem 0 0;
    }
    #glossary-selection{
      margin: 0 0 0 1rem;
    }
    select{
      width: 15rem;
      margin-left: 5px;
      color: #999;
      font-size: 12px;
      padding: 7px 30px 7px 10px;
      border-radius: 5px;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      &::-ms-expand { display: none;}

      background-image: url(/img/16_tri.svg);
      background-repeat: no-repeat;
      background-size: 24px 12px;
      background-position: right 10px center;
    }
  }
}

.file-translation-main {
  margin: 1rem;
  border: 2px dashed;
  border-radius: 10px;
  font-size: 20px;
  color: #b0b0b0;
  background-color: #ffffff;
  text-align: center;
  padding: 50px 0;
  line-height: 35px;
  .content-text{
    width: 100%;
  }
}

.supported-file-types {
  box-sizing: border-box;
  width: min(720px, calc(100% - 48px));
  margin: 1rem auto 0;
  padding: 0.65rem 0.9rem;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  background: #fafafa;
  font-size: 12px;
  line-height: 1.55;
  color: #666666;
  text-align: left;

  &__row {
    display: flex;
    gap: 0.75rem;
    align-items: flex-start;
  }

  &__row + &__row {
    margin-top: 0.2rem;
  }

  &__label {
    flex: 0 0 6.5rem;
    color: #555555;
    font-weight: 600;
    white-space: nowrap;
  }

  &__body {
    flex: 1;
    min-width: 0;
  }
}

@media (max-width: 640px) {
  .supported-file-types {
    width: calc(100% - 28px);

    &__row {
      display: block;
    }

    &__label {
      display: block;
      margin-bottom: 0.05rem;
    }
  }
}

#file-translation-foot {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0;
  .btn-translate{
    padding: 0.25rem 0;      
    button{
      font-size: large;
      width: 7.75rem;
    }
  }
}

.circle {
  font-size: 13px;
  color: #ffffff;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgb(160,122,190);
  text-align:center;
  line-height: 20px;
  margin: 0 0.3rem;
}

@media screen { 
  #trans-file-input { display: none; }
}

.trans-file-btn {
  background-color: #b0b0b0;
  padding: 5px 20px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 20px;
  color: white;
}

.trans-file-btn:hover {
  cursor: pointer;
  background-color: #d0d0d0;
}

#trans_file_name {
    font-size: 14px;
    margin-left: 20px;
}

.reset_file_ico {
    padding: 2px 4px;
    font-size: 12px;
    border-radius: 10px;
    background: #FF9B9A;
    color: white;
    font-weight: bold;
}

.reset_file_ico:hover {
    cursor: pointer;
    background: #FFBBBB;
}

.drag_on {
  background-color: #eee;
}

.modalArea{
  position: fixed;
  text-align: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 5px;
  background:rgba( 0,0,0,0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5), 0 26px 52px rgba(0, 0, 0, 0.3);
  overflow: auto;
  height:100vh;
  z-index: 999;
}
.modalWrapper{
margin-top:15%;
}
.modalContents{
  color:black;
  background-color: gray;
  padding: 2rem;
}

#modalMessage{
  color: white;
}

span.loading {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 100px;
  border: 5px solid #000;

  border-radius: 55px;

  -webkit-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}

/*輪の区切り*/
span.loading:before {
  position: absolute;
  display: inline-block;
  content: " ";
  left: 100%;
  top: 50%;
  margin-top: -15px;
  margin-left:-10px;
  width: 20px;
  height: 30px;
  background-color: rgba(127,127,127,1);
}

/*矢印*/
span.loading:after {
  position: absolute;
  display: inline-block;
  content: " ";
  left: 100%;
  top: 50%;
  margin-top: -20px;
  margin-left:-10px;
  border: 10px solid transparent;
  border: 10px solid rgba(0, 0, 0, 0);
  border-top: 20px solid #000;
}

.flex-container {
  display: flex;
  align-items: center;
}

/*回転*/
@-webkit-keyframes rotating {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.redirect-page-button{
  font-size: 2rem;
  padding: 0rem 3rem;
  margin: 2rem 4rem;
}

@media (max-width: 1000px) {
  #file-translation-head { font-size: 0.8rem; display: grid; }
  #file-translation-head #selection .select_ai_setting{ width: 10rem; }
}

@media (max-width: 500px) {
  #file-translation-head #selection .select_ai_setting{ width: 7rem; }
}
</style>
